






















































































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";
import SignableDocumentsDTO from "@/dto/signature/SignableDocumentsDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import SignatureService from "@/services/SignatureService";
import SignableDocumentsFilter from "@/dto/signature/SignableDocumentsFilter";
import {processError} from "@/utils/ComponentUtils";
import PersonSearch from "@/components/common/PersonSearch.vue";
import PersonDTO from "@/dto/person/PersonDTO";
import {DocumentSigningStatus} from "@/constants/SignatureConstants";
import SelectOption from "@/components/common/SelectOption";
import PortalSelect from "@/components/common/PortalSelect.vue";
import DocumentUtils from "@/utils/DocumentUtils";
import Notifications from "@/state/Notifications";
import SignersDTO from "@/dto/signature/SignersDTO";
import SublimeSearch from "@/components/common/SublimeSearch.vue";
import SublimeEmployeeDTO from "@/dto/sublime/employee/SublimeEmployeeDTO";
import PortalDate from "@/components/common/PortalDate.vue";
import SelectProfileTypeForPrefilledDocumentModal
	from "@/components/documents/signing/SelectProfileTypeForPrefilledDocumentModal.vue";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import {debounce} from "typescript-debounce-decorator";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import Application from "@/state/Application";

const AppModule = namespace("App");

export type Analytics = {
	created: number;
	partiallySigned: number;
	signed: number;
	cancelled: number;
	declined: number;
};

@Component<SignableDocumentsListNew>({
	components: {
		BTPortalCollapse,
		PortalInput,
		SimpleProfileSearch,
		PortalDate,
		SublimeSearch,
		PortalSelect,
		PersonSearch,
		PaginationComponent,
		DeleteConfirmation
	},
	computed: {
		SelectOption() {
			return SelectOption
		},
		DocumentSigningStatus() {
			return DocumentSigningStatus;
		},
		DocumentUtils() {
			return DocumentUtils;
		},
		activeFiltersCount(): number {
			let count = 0;

			// Проверяем название документа
			if (this.filter.titleSearch && this.filter.titleSearch.trim()) {
				count++;
			}

			// Проверяем статус подписания
			if (this.filter.signingStatus) {
				count++;
			}

			// Проверяем подписанта
			if (this.filter.signerId) {
				count++;
			}

			// Проверяем ответственного
			if (this.filter.assigneeId) {
				count++;
			}

			// Проверяем даты
			if (this.filter.createDateFrom) {
				count++;
			}
			if (this.filter.createDateTo) {
				count++;
			}

			return count;
		}
	}
})
export default class SignableDocumentsListNew extends Vue {

	@AppModule.Action
	private startLoading!: () => void

	@AppModule.Action
	private stopLoading!: () => void

	private signer: ProfileDTO | null = null;
	private signableDocuments: Array<SignableDocumentsDTO> | [] = [];
	private filter = new SignableDocumentsFilter();
	private totalPages = 1;
	private isCancelDocumentModalShown = false;
	private documentIdToDelete: number | null = null;
	private activeDropdownId: number | null = null;
	private filterKey = 0

	selectedEmployee: SublimeEmployeeDTO | null = null;

	// Аналитика документов
	private analytics: Analytics = {
		created: 0,
		partiallySigned: 0,
		signed: 0,
		cancelled: 0,
		declined: 0
	};

	// Состояние свернутости фильтров
	private filtersCollapsed = false;

	mounted(): void {
		this.loadDocuments();
		document.addEventListener('click', this.handleOutsideClick);
	}

	beforeDestroy(): void {
		document.removeEventListener('click', this.handleOutsideClick);
	}

	handleOutsideClick(event: MouseEvent): void {
		const target = event.target as HTMLElement;
		if (!target.closest('.document-actions')) {
			this.activeDropdownId = null;
		}
	}

	toggleDropdown(docId: number): void {
		this.$nextTick(() => {
			if (this.activeDropdownId === docId) {
				this.activeDropdownId = null;
			} else {
				this.activeDropdownId = docId;
			}
		});
	}

	@debounce(500)
	loadDocuments(): void {
		this.startLoading();
		SignatureService.getSignableDocuments(this.filter).then(
			response => {
				response.data.content.forEach(doc => {
					doc.signers = doc.signers.sort((a, b) => a.order - b.order);
				})
				this.signableDocuments = response.data.content;
				this.totalPages = response.data.totalPages;
			},
			error => {
				processError(error, this);
				this.stopLoading();
			}
		)
			.then(this.calculateAnalytics)
			.finally(this.stopLoading);
	}

	private calculateAnalytics(): Promise<void> {
		return SignatureService.getAnalytics().then(
			response => {
				this.analytics = response.data;
			},
			error => {
				processError(error, this);
			}
		);
	}

	private selectSigner(signer: PersonDTO) {
		this.filter.signerId = signer.id;
		this.filter.signerType = signer.type;
		this.loadDocuments();
	}

	changePage(page: number): void {
		this.filter.pageNumber = page;
		this.loadDocuments();
	}

	clearFilter(): void {
		this.filterKey = this.filterKey + 1
		this.filter = new SignableDocumentsFilter();
		this.loadDocuments();
	}

	goToCustom(): void {
		this.$router.push({name: this.$routeNames.ARCHIVE_SIGNABLE_CUSTOM, params: this.$route.params})
	}

	sendPrefilled(): void {
		this.$modal.show(
			SelectProfileTypeForPrefilledDocumentModal,
			{
				onCreated: () => {
					this.clearFilter();
					Notifications.info('Document has been sent');
				}
			}
		)
	}

	sendReminder(signer: SignersDTO): void {
		this.startLoading();
		SignatureService.sendReminder(signer.id).then(
			ok => {
				Notifications.info(`Reminder for ${signer.name} has been sent`);
				this.stopLoading();
			},
			err => {
				processError(err, this);
				this.stopLoading();
			}
		)
	}

	onEmployeeChanged(employee: SublimeEmployeeDTO): void {
		this.filter.assigneeId = employee.id;
		this.loadDocuments();
	}

	triggerCallback(documentId: number): void {
		this.startLoading();
		SignatureService.triggerCallback(documentId).then(
			ok => {
				this.stopLoading();
			},
			err => {
				processError(err, this);
				this.stopLoading();
			}
		)
	}

	toggleCancelDocumentModal(documentId?: number): void {
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => this.cancelDocument(),
				targetName: "",
				operationName: "cancel document",
				cancelButtonName: "Close"
			}
		)

		if (documentId) this.documentIdToDelete = documentId;
		else this.documentIdToDelete = null;

		this.isCancelDocumentModalShown = !this.isCancelDocumentModalShown;
	}

	cancelDocument(): void {
		this.startLoading();
		SignatureService.cancelDocument(this.documentIdToDelete as number).then(
			ok => {
				this.stopLoading();
				this.loadDocuments();
				Notifications.info("Document has been canceled");
			},
			err => processError(err, this)
		);
	}

	downloadDocument(fileId: number): void {
		DocumentUtils.download(fileId);
	}

	filterByStatus(status: string): void {
		// Очищаем предыдущие фильтры по статусу
		this.filter.signingStatus = null;

		// Устанавливаем соответствующий статус
		switch (status) {
			case 'created':
				this.filter.signingStatus = DocumentSigningStatus.CREATED;
				break;
			case 'partially_signed':
				this.filter.signingStatus = DocumentSigningStatus.PARTIALLY_SIGNED;
				break;
			case 'signed':
				this.filter.signingStatus = DocumentSigningStatus.SIGNED;
				break;
			case 'cancelled':
				this.filter.signingStatus = DocumentSigningStatus.CANCELLED;
				break;
			case 'declined':
				this.filter.signingStatus = DocumentSigningStatus.DECLINED;
				break;
		}

		// Сбрасываем номер страницы и загружаем документы
		this.filter.pageNumber = 1;
		this.loadDocuments();

		// Показываем уведомление
		Notifications.info(`Filtered by ${status} status`);
	}

	clearStatusFilter(): void {
		// Очищаем фильтр по статусу
		this.filter.signingStatus = null;

		// Сбрасываем номер страницы и загружаем документы
		this.filter.pageNumber = 1;
		this.loadDocuments();

		// Показываем уведомление
		Notifications.info('Status filter cleared');
	}
}
